const API = process.env.REACT_APP_API_BASE_URL || 'https://admin.goridesrw.com/api/remote';
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export function attribution() {
  try {
    let visit = JSON.parse(sessionStorage.getItem('gorides-visit') || 'null');
    if (!visit || Date.now() - visit.started > 86400000) {
      const params = new URLSearchParams(window.location.search);
      const ref = params.get('ref');
      let source = params.get('utm_source');
      if (!source && document.referrer) { const url = new URL(document.referrer); if (url.hostname !== window.location.hostname) source = url.hostname; }
      visit = { sessionId: crypto.randomUUID(), started: Date.now(), source: /^[a-zA-Z0-9._-]{1,80}$/.test(source || '') ? source.toLowerCase() : (ref ? 'partner' : 'direct'), referral: /^[a-z0-9-]{3,32}$/.test(ref || '') ? ref : null };
      sessionStorage.setItem('gorides-visit', JSON.stringify(visit));
    }
    return visit;
  } catch { return { sessionId: null, source: 'direct', referral: null }; }
}
export function trackDiscovery(type, carId) {
  const visit = attribution(); if (!visit.sessionId || navigator.doNotTrack === '1') return;
  const path = window.location.pathname.startsWith('/car/') ? `/car/${carId || ''}` : window.location.pathname;
  const publicPath = /^\/$|^\/(browse|drivers|car-rental-kigali|suv-rental-rwanda|car-rental-with-driver)$|^\/car\/[a-f0-9-]+$/.test(path) ? path : '/';
  fetch(`${API}/public/discovery/events`, { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ id:crypto.randomUUID(),sessionId:visit.sessionId,type,source:visit.source,referral:visit.referral,path:publicPath,carId: UUID.test(carId || '') ? carId : null }) }).catch(() => {});
}
export async function sendEnquiry(payload) {
  const visit = attribution();
  const response = await fetch(`${API}/public/discovery/enquiries`, { method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({...payload,sessionId:visit.sessionId,source:visit.source,referral:visit.referral}) });
  if (!response.ok) { let message='Could not send your enquiry. Please try again.'; try { const error=await response.json(); message=error.detail || error.message || message; } catch {} throw new Error(message); }
  return response.json();
}
